import AbstractFormStep from "../AbstractFormStep.js";

/**
 * Wizard step asking the user to select something from a list, the item
 * selected is sent back as selection in the callback.
 * This step automatically submits on start if there is just one item.
 *
 * @param {Renderable} spec.dropdownLabel - The label of the dropdown
 * @param {function} spec.getItemsFromContext - A function taking a context
 *   as parameter, and returning a list of items to fill the dropdown
 * @param {function} spec.submitCallback - A function to execute once
 *   the step is completed, it receives a selection containing the item
 *   selected, and a onDone function that has to be called when the callback
 *   has finished submitting
 */
export default class DropdownSelectionStep extends AbstractFormStep {
	constructor({ dropdownLabel, getItemsFromContext, submitCallback, name }) {
		super(...arguments);

		this._dropdownLabel = dropdownLabel;
		this._getItemsFromContext = getItemsFromContext;
		this._submitCallback = submitCallback;
		this._name = name;
	}

	_populateForm(form) {
		this._items = this._getItemsFromContext(this._context);

		this._selectedItem = (
			this._items.find((item) => item.selected) || this._items[0]
		).value;

		this._dropdown = form.newDropDownField({
			items: this._items,
			label: this._dropdownLabel,
			attribute: "stepDropdownValue",
			name: this._name,
			dataTestName: "select-item",
			liveSearch: true,
			onChange: (value) => {
				this._selectedItem = value;
			},
		});
	}

	_shouldSubmitOnStart() {
		return this._items.length === 1;
	}

	_doSubmit({ onDone }) {
		this._submitCallback({
			step: this,
			onDone,
			selection: this._selectedItem,
		});
	}
}
